import React from "react";
import Card1 from "./Cards/card1";
import Card2 from "./Cards/card2";
import Card2Extended from "./Cards/card2-multicolor";
import Card3 from "./Cards/card3";
import Card4 from "./Cards/card4";
import Card5 from "./Cards/card5";
import Card6 from "./Cards/card6";
import Card7 from "./Cards/card7";
import Card8 from "./Cards/card8";
import Card9 from "./Cards/card9";
import Resources from "./Cards/resources";
import DefaultCard from "./Cards/default";
import VideoCard from "./Cards/videocard";

const CardsAssembly = (props) => {

    switch (props.content.type) {
        case "Card 1":
            return <Card1 content={props.content} />;
        case "Card 2":
            return <Card2 content={props.content} />;
        case "Card 2 - Multicolor":
            return <Card2Extended content={props.content} />;
        case "Card 3":
            return <Card3 content={props.content} />;
        case "Card 4":
            return <Card4 content={props.content} />;
        case "Card 5":
            return <Card5 content={props.content} />;
        case "Card 6":
            return <Card6 content={props.content} />;
        case "Card 7":
            return <Card7 content={props.content} />;
        case "Card 8":
            return <Card8 content={props.content} />;
        case "Card 9":
            return <Card9 content={props.content} />;
        case "Resources":
            return <Resources content={props.content} />;
        case "Video":
            return <VideoCard content={props.content} />;
        default:
            return <DefaultCard content={props.content} />;
    }
};

export default CardsAssembly; 